import {
  generateId, unMaskInput, HaToacOnly, unMaskInputValue,
  cmToFineDry,
} from 'utils/helpers';
import { Metric } from 'utils/constants';
import { useCroptimizer } from 'features/Croptimizer/providers/CroptimizerContext';
import { CropProps } from 'utils/types';

import { useGenerateCrop } from './useGenerateCrop';

export const useAddField = (currentCrop: CropProps) => {
  const { boardSoilValues, boardStatusValues, metricValue, setFields, setActiveTabCrop } = useCroptimizer();

  const { generateCrop } = useGenerateCrop();

  const addField = (isOnlyOne?: boolean) => () => {
    const id = generateId();
    const object = {
      soilTypeI: boardSoilValues?.soilType ?? '',
      secI: boardSoilValues?.secsmol ?? '',
      currentphI: unMaskInputValue(boardStatusValues?.currentPh || '5,8'),
      currentSecI: boardStatusValues?.currentSec ?? '',
      targetphI: unMaskInputValue(boardStatusValues?.targetPh || '6,3'),
      targetSecI: boardStatusValues?.targetSec ?? '',
      productTypeI: boardSoilValues?.productName ?? '',
      nvI: boardSoilValues?.nv ?? '',
      mtI: boardSoilValues?.mt ?? '',
      fineAndDry: cmToFineDry(Number(unMaskInput(boardSoilValues?.fineDrySoil ?? '20'))),
      areaI: unMaskInputValue(
        metricValue === Metric.metric ? '10' : String(HaToacOnly(10)),
      ),
    };

    const field = {
      id,
      title: '',
      object: {
        ...object,
        tableDataI: [generateCrop(currentCrop, object)],
      },
    };
    setFields((prev: any) => (isOnlyOne ? [field] : [...prev, field]));

    setActiveTabCrop(id);
  };

  return {
    addField,
  };
};